import styled from '@emotion/styled/macro';
import theme from 'ui/theme/theme';
import { Checkbox, Radio, RadioGroup } from '@chakra-ui/react';

export const StyledCheckbox = styled(Checkbox)`
  border-color: ${theme.colors.semantics.default};
  border-radius: 2px;
  margin-bottom: 8px;

  .chakra-checkbox__control[data-checked] {
    background: ${theme.colors.semantics.default};
  }
`;

export const StyledRadioButton = styled(Radio)`
  border-color: ${theme.colors.semantics.default};
  border-radius: 50%;

  &[data-checked]::before {
    background: ${theme.colors.semantics.default};
  }
`;

export const StyledRadioGroup = styled(RadioGroup)`
  display: flex;
  flex-direction: column;

  label {
    margin-bottom: 8px;
  }
`;

export const HR = styled.hr`
  border-top: 1px solid ${theme.colors.gray['500']};
  margin: 24px 0;
`;
